import { install as InstallAttributeEditors } from './itemEditor/attributeEditors/PluginSetup.js';
import Validators from './itemEditor/attributeValidators/PluginSetup.js';
const install = molten => {
  InstallAttributeEditors(molten);
  Validators.install(molten);
};
export default {
  install
};